import { clearCurrentUser } from 'store/current-user/actions';
import { HttpStatus } from 'models/api/http-status';
import { showToast } from 'store/application/actions';
import { ApiError } from 'models/api/http';
import { ToastType } from 'models/app/toast';

export const withTotalCount = { withTotal: true };
export const withSkipImages = { skipImages: true };

export const createErrorActions = (error) => {
    const handlers = [
        {
            predicate: () => error.unauthorized,
            handler: () => [clearCurrentUser()],
        },
        {
            predicate: () => true,
            handler: () => [showToast(
                {
                    type: ToastType.error,
                    message: error?.message || 'Unhandled Error',
                },
            )],
        },
    ];

    return handlers.filter(({ predicate }) => predicate())[0].handler();
};


export const createApiError = (fetchError): ApiError => {
    const status = fetchError.response?.status;

    const error = new Error(fetchError?.apiResponseObject?.message || '') as ApiError;

    // error.handled = !config.noErrorHandling;
    error.forbidden = status === HttpStatus.FORBIDDEN;
    error.unauthorized = status === HttpStatus.UNAUTHORIZED || (status === HttpStatus.INTERNAL_SERVER_ERROR && fetchError.message === 'jwt expired');
    error.offline = status === HttpStatus.SERVICE_UNAVAILABLE || status === HttpStatus.GATEWAY_TIMEOUT;

    error.status = status;
    error.message = fetchError.response?.message || fetchError.apiResponseObject.message;
    error.data = fetchError.apiResponseObject;
    error.actions = createErrorActions(error);

    return error;
};
